import Chip, { type ChipProps } from '@mui/material/Chip';
import {
  STRATEGY_STATUS_CANCELED,
  STRATEGY_STATUS_ACTIVE
} from '../../shared/AppConstants';
import type { DMSMStrategy } from '../../types/apis/dmsm/dmsm.types';

type Props = {
  strategy: Pick<DMSMStrategy, 'currentPhase' | 'status'>;
};

export function PhaseAndStatusBadge({ strategy }: Props) {
  const isCanceled = strategy.status === STRATEGY_STATUS_CANCELED;

  const color = (
    isCanceled
      ? 'error'
      : strategy.status === STRATEGY_STATUS_ACTIVE
        ? 'success'
        : 'informational'
  ) as ChipProps['color'];

  return (
    <Chip
      color={color}
      variant={'badge'}
      icon={isCanceled ? <fuel-icon name="delete" /> : undefined}
      label={`${strategy.status} - Phase ${strategy.currentPhase}`}
      sx={
        isCanceled ? { '& .MuiChip-label': { fontWeight: 'bold' } } : undefined
      }
    />
  );
}
